import React, { Component } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { statuses } from "../../../constants/option";
import DatePicker from "../../inputs/DatePicker";
import Select from "../../inputs/Select";
import TextInput from "../../inputs/TextInput";
import { Button } from "../../util/Clickable";
import * as validate from "../../util/Validator";

class NewsForm extends Component {
  state = {
    loading: false,
  };

  onChange = (mode) => {
    this.setState({ mode: mode });
  };

  onSubmit = (values) => {
    this.setState({
      loading: true,
    });
    return this.props.onSubmit(values).then(({ value, action }) => {
      if (value.status < 300) {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.props.onSuccess &&
              this.props.onSuccess(value.data, value.response);
          },
        );
      } else {
        this.setState({
          loading: false,
        });
        const errors = Object.keys(value.errors).reduce((dic, key) => {
          dic[key] = Array.isArray(value.errors[key])
            ? value.errors[key].join("\n")
            : null;
          return dic;
        }, {});
        throw new SubmissionError(errors);
      }
    });
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-small">
          <Field
            name="title"
            type="text"
            component={TextInput}
            label="Title"
            validate={[validate.required]}
            required
          />
        </div>
        <div className="uk-margin-small uk-child-width-1-2@s" data-uk-grid>
          <div>
            <Field
              name="posted_at"
              component={DatePicker}
              label="Post Date"
              validate={[validate.required]}
              required
            />
          </div>
          <div>
            <Field
              name="status"
              component={Select}
              label="Status"
              validate={[validate.required]}
              required
              options={statuses}
            />
          </div>
        </div>
        <div className="uk-margin-small">
          <Field
            name="link_url"
            type="url"
            component={TextInput}
            label="Link URL"
          />
        </div>

        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin uk-text-center">
          <Button
            className="uk-button uk-button-default"
            type="submit"
            disabled={this.props.invalid}
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            Submit
          </Button>
        </div>
      </form>
    );
  };
}

export default reduxForm({
  form: "admin-news-form",
  enableReinitialize: true,
})(NewsForm);
